import _ from "lodash";
import Radium from "radium";
import React from "react";

import { IUser } from "@common/models";
import { styles } from "@common/styles";
import SearchBar from "./search-bar";
import Pagination from "./pagination";
import UserList from "./user-list";
import UserListHeader from "./user-list-header";

export interface IAdminUsersProps {
  users: IUser[];
  totalUsers: number;
}

export interface IAdminUsersActions {
  getUsers: (
    skip?: number,
    searchText?: string,
    activeOnly?: boolean,
    sort?: string,
    reverseOrder?: boolean
  ) => void;
  editUser: (userId: string) => void;
}

export interface IAdminUsersState {
  activeOnly: boolean;
  reverseOrder: boolean;
  skip: number;
  skipCount: number;
  searchText: string;
  sort: string;
}

class AdminUsers extends React.Component<
  IAdminUsersProps & IAdminUsersActions,
  IAdminUsersState
> {
  constructor(props) {
    super(props);
    this.state = {
      reverseOrder: false,
      skipCount: 20,
      skip: 0,
      activeOnly: false,
      searchText: "",
      sort: ""
    };
  }

  componentDidMount() {
    this.props.getUsers();
  }

  public render() {
    const { users, totalUsers } = this.props;
    const { skip, skipCount, activeOnly, searchText } = this.state;

    const skipStart = skip ? skip : 0;
    const skipEnd =
      skipStart + skipCount <= totalUsers ? skipStart + skipCount : totalUsers;

    return (
      <div
        className="flexColumnContent"
        style={styles.flexColumnContent as any}
      >
        <div className="headerWrapper" style={styles.headerWrapper as any}>
          <div
            className="pageHeaderWithExtras"
            style={styles.pageHeaderWithExtrasContainer as any}
          >
            Administrer brukere
          </div>
          <div
            className="extrasContainer"
            style={styles.extrasContainer as any}
          >
            <SearchBar
              placeholder="Søk etter bruker"
              onSearchInputChanged={this.handleSearchInput}
              onShowActiveChange={this.handleShowActiveChange}
              searchText={searchText}
              activeOnly={activeOnly}
            />
            <Pagination
              onPagination={this.handlePagination}
              skip={skip}
              skipCount={this.state.skipCount}
              userCount={totalUsers}
            />
          </div>
        </div>
        {totalUsers ? (
          <div
            className="subHeaderContainer"
            style={styles.subHeaderContainer as any}
          >
            Viser {skipStart} - {skipEnd} av {totalUsers}{" "}
            {activeOnly ? "aktive" : ""} brukere
          </div>
        ) : null}
        <div
          className="contentContainer"
          style={styles.contentContainer as any}
        >
          <div className="flexList">
            <UserListHeader
              reverseOrder={this.state.reverseOrder}
              handleSortUsers={this.handleSortUsers}
            />
            {totalUsers ? (
              <UserList users={users} editUser={this.props.editUser} />
            ) : (
              <div className="noData" style={styles.noData as any}>
                {searchText
                  ? "Søket '" + searchText + "' ga ingen resultater"
                  : "Fant ingen brukere"}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  private handleShowActiveChange = activeOnly => {
    this.setState(
      {
        activeOnly
      },
      () => {
        const { searchText, activeOnly, skip } = this.state;
        this.props.getUsers(skip, searchText, activeOnly);
      }
    );
  };
  private handleSearchInput = searchText => {
    this.setState(
      {
        searchText
      },
      this.debouncedSearchTearmUpdate
    );
  };

  private debouncedSearchTearmUpdate = _.debounce(() => {
    const { searchText, activeOnly, skip } = this.state;
    this.props.getUsers(skip, searchText, activeOnly);
  }, 500);

  private handlePagination = currSkip => {
    this.setState({ skip: currSkip }, () => {
      const { searchText, activeOnly, skip } = this.state;
      this.props.getUsers(skip, searchText, activeOnly);
    });
  };

  private handleSortUsers = (sort, reverseOrder) => {
    const reverse = reverseOrder ? false : true;
    this.setState({ reverseOrder: reverse, sort }, () => {
      const { searchText, activeOnly, skip } = this.state;
      this.props.getUsers(skip, searchText, activeOnly, sort, reverse);
    });
  };
}

export default Radium(AdminUsers);
